import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/Dhaka_Resume_F2.pdf";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [spojRank, upadteSpojRank] = useState(0);
  const [hackerrank, upadteHackerank] = useState(0);
  const [sem, upadateSem] = useState(0);
  const [cgpa, upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
            <h3 className="resume-title">Experience</h3>
            <Resumecontent
              title="Data Analyst @ University of Texas Reporting, Analytics and Data Team"
              date="January 2021 - May 2021"
              content={[
                " Scraped 2250 IRS 990 forms of foundations as XML files from an AWS server. Improved data collection efficiency by 53.5% and reduced resource engagement time by 33%. (fuzzy data matching, clustering, NLP)",
                " Raised the university’s fundraising revenue by $1.4M per year by implementing predictive models to gauge the giving capacity of foundations to facilitate the university’s fundraising. (k-Nearest Neighbours - preliminary analysis)",
              ]}
            />
            <Resumecontent
              title="Data Science Research Assistant @ University of Texas at Austin"
              date="January 2020 - December 2020"
              content={[
                " Web scraped a dataset of 4000 questions on user data privacy and their metrics (titles, summaries, tags, accepted answers, most voted answers) from StackOverflow. (Python, BeautifulSoup)",
                " Created a bag of words corpus using the downloaded text. (gensim, pandas, nltk)",
                "Used Natural Language Processing for analysing the text data to find trends in developers’ questions.(Latent Dirichlet Allocation for topic modeling, n-gram algorithms, TF-IDF and lemmatization)",
              ]}
            />
            <Resumecontent
            title="Associate Product Specialist @ Sabre, Bangalore"
            date="October 2018 - July 2019"
            content={[
              " Analysed and resolved complex problems at multiple layers (application, environment, database, networking) using proprietary software and diagnostics tools. (Postman, SQL, API Testing)",
              " Saved Sabre $300,000 in fines to the client by resolving 25 high severity issues preventing system failure.",
              "Trained on product installation and data migration on HP servers.",
            ]}
          />
          <Resumecontent
            title="Associate Product Specialist @ Sabre, Singapore"
            date="August 2018 - September 2018"
            content={[
              " Developed an employee leave module for SilkAir crew members. Defined criteria for leave allocation. Synched the module with the customer database to ensure crew rosters were published on time. Processed leave requests, and used web services to transfer the data as XML files. (SQL, MS Excel, Postman)",
              " Saved the client $32,000 by publishing the final rosters a month in advance.",
            ]}
          />
            {/*<h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="Web Developer [Pantheon-2019 Technical Fest of BIT Mesra]"
              content={[
                "Worked on creating the frontend-end of the website using Bootstrap, Javascript.",
              ]}
            />
            <Resumecontent
              title="Web Developer [Bitotsav-2020 Technical Fest of BIT Mesra]"
              content={[
                "Operated on developing the frontend end of the website using Bootstrap, Javascript and backend APIs using Node.js",
              ]}
            />*/}
            </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="MS in Information Science "
              date="University of Texas at Austin"
              content={[`2019 - 2021`, 'GPA: 3.93', 'Minor 1: Data Science', 'Minor 2: UX Research']}
            />
            <Resumecontent
              title="Bachelors in Electronics and Communication Engineering"
              date="Manipal Institute of Technology"
              content={['2014 - 2018', 'GPA: 3.4', 'Head of Operations of Manipal Information Security Team (MIST)', 'Varsity Basketball Team', 'Rotary Club']}
            />
            <Resumecontent
              title="High School "
              date="St. Joseph's Academy"
              content={['2002 - 2014', 'Sports Captain', 'Basketball Team Captain']}
            />
            {/*<h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                `Current rank in Spoj ${spojRank}`,
                `Current rank in HackerRank  ${hackerrank}`,
                "Top Performer in Code-Break 1.0",
                "Participant in Hack-A-Bit 2019",
              ]}
            />*/}
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;
